import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import {
  PaymentElement,
  CardElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { userId } from "../../Utils/LocalStorage";
import { toast } from "react-toastify";
import { ServerError } from "../../Utils/ErrorMessages";
import { StripepaymentApi } from "../../Utils/Api/StripepaymentApi";
import {
  getMySubscriptionPlan,
  getMySubscriptionPlanName,
} from "../../redux/MyProfileSubscriptionSlice";
import { RotatingLines } from "react-loader-spinner";

const CheckoutForm = ({ setLoading, fontSize, amountprice, couponData }) => {
  const user_id = userId();
  const navigate = useNavigate();

  const data = useSelector((state) => state.PersistedData);
  const planId = data?.MyProfileSubscription?.MySubscriptionPlanId;

  const dispatch = useDispatch();

  const stripe = useStripe();
  const elements = useElements();
  const [paymentError, setPaymentError] = useState(null);
  const [clicked, setClicked] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    if (!stripe || !elements) {
      return;
    }

    const cardElement = elements.getElement(CardElement);

    try {
      setClicked(true);
      const { paymentMethod, error } = await stripe.createPaymentMethod({
        type: "card",
        card: cardElement,
      });
      if (error) {
        console.error("Stripe Error:", error);
        setPaymentError(error.message);
        setLoading(false);
        setClicked(false);
      } else {
        const data = {
          token: paymentMethod.id,
          user_id: user_id,
          plan_id: planId,
          coupon_code: couponData,
          is_coupon_applied: !couponData ? false : true,
        };

        if (paymentMethod.id) {
          StripepaymentApiHandler(data);
        } else {
          setLoading(false);
        }
      }
    } catch (error) {
      setPaymentError(error);
      setLoading(false);
      setClicked(false);
    }
  };

  const StripepaymentApiHandler = async (data) => {
    const Stripepaymentres = await StripepaymentApi(data, () => {
      navigate("/");
    });
    if (Stripepaymentres === false) {
      toast.error(ServerError, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setLoading(false);
    } else {
      if (Stripepaymentres?.success === true) {
        // navigate("/my-profile/transaction-successful");
        // setLoading(false);
        dispatch(
          getMySubscriptionPlanName(
            planId === 1
              ? "You can create 1 voucher, 1 coupon and subscribe to 1 marketplace with this plan. T&C applied."
              : planId === 2
              ? "You can create up to 3 vouchers, 3 coupons and subscribe to 3 marketplaces with this plan. T&C applied."
              : "You can create unlimited vouchers & coupons and subscribe to all marketplaces with this plan. T&C applied."
          )
        );
        dispatch(
          getMySubscriptionPlan(
            planId === 1 ? "Free" : planId === 2 ? "Tier II" : "Tier III"
          )
        );
        setLoading(false);
        navigate("/my-profile/transaction-successful");
      }else if (Stripepaymentres.status === 429) {
        setLoading(true);
        toast.error(Stripepaymentres.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }  else {
        toast.error(Stripepaymentres.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        navigate("/my-profile/transaction-failed");
        setLoading(false);
      }
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {amountprice === 0 ? (
        <p className="zero_Charge">
          Your current charges are $0 for this month, however we will need your
          credit card info on file for future subscription charges.
        </p>
      ) : (
        <></>
      )}
      <CardElement
        // options={createOptions(fontSize)}
        className="card_Element"
        id="card-element"
      />
      <p className="autofill">
        To save your card for future transactions, click on the link "Autofill"
        button above and create your account.(optional)
      </p>
      <div className="stripe_Popup_Button">
        <button type="submit" disabled={!stripe || !elements}>
          {clicked === true ? (
            <RotatingLines strokeColor="white" width={20} visible={true} />
          ) : amountprice === 0 ? (
            "Update subscription"
          ) : (
            "Pay $" + amountprice
          )}
        </button>
      </div>
      {paymentError && <div className="payment_Error">{paymentError}</div>}
    </form>
  );
};

export default CheckoutForm;
